import React, { useState, useEffect, useMemo, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Footer from "../../components/footer";
import Header from "../../components/header";
import AppTextField from "../../components/text-field/component";
import { Link } from "react-router-dom";
import AppButton from "../../components/button/component";
import Facebook from "../../assets/logo/facebook.svg";
import AppleLogo from "../../assets/logo/apple.svg";
import AppleSignin from "react-apple-signin-auth";
import {
  getPortalCD,
  isAllAddressCookiePresent,
  getIPConfig,
} from "../../utils/helpers";
import {
  CAREER_PREFERENCE_TEST_ASSESSMENT_ID,
  CAREER_TEST_ASSESSMENT_ID,
  ENNEAGRAM_TEST_ASSESSMENT_ID,
  FacebookAppId,
  generateContentKey,
  invalidMailboxStatuses,
  removeWhitespace,
  ROMANTIC_COMPATIBILITY_ASSESSMENT_ID,
  wrapScoresWithTraitLevel,
  AppleCliendId,
  AppleRedirectUrl,
  PERSONALITY_TEST_ASSESSMENT_ID,
} from "../../utils/general-config";
import { APP_NAVIGATION, LOCALE } from "../../utils/constants";
import PathHelper from "../../utils/path-helper";

import { toast } from "react-toastify";
import {
  isValidGuid,
  validateEmail,
  validatePassword,
} from "../../utils/validation";
import { readCookie } from "../../utils/helpers";
import { useGoogleLogin } from "@react-oauth/google";
import GoogleLoginLogo from "../../assets/logo/google-normal.svg";
import { FacebookProvider, LoginButton } from "react-facebook";
import { trackEvents } from "../../utils/tracking-events";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Loader from "../../components/loader";
import {
  convertToLowerCase,
  getCountryCode,
  InvitationStatus,
} from "../../utils/utility-functions";

import { loadScript, removeScript } from "../../utils/helpers";
import { traitType } from "../../services/enum/environment-enum";
import useSignOut from "../../utils/sign-out";
import { useDispatch } from "react-redux";
import FunnelStepTypes from "../funnel-step/types";
import GoogleCaptcha from "./capcha";
// import { TrackEvent, VerifyCaptcha } from "../sign-up/actions";
import { getGoogleCaptchaKey } from "../../utils/general-config";

import jwtDecode from "jwt-decode";
import Footer_V2 from "../../components/footer-v2/component";

const PushGuestUserToFunnelStep = (guestUser) => {
  return {
    type: FunnelStepTypes.SET_GUEST_USER,
    guestUser,
  };
};
const PushUserInformationToFunnelStep = (userInformation) => ({
  type: FunnelStepTypes.SET_USERINFO,
  payload: userInformation,
});
const PushDashboardAbTestValueFunnelStep = (dashboardAbTestValue) => {
  return {
    type: FunnelStepTypes.SET_DASHBOARD_AB_TEST_VALUE,
    dashboardAbTestValue,
  };
};

const SignupIQ = ({
  createUserAccountConnect,
  funnelStep,
  createExternalUserAccountConnect,
  updateUserIdConnect,
  getContentLatestVersionConnect,
  getAssessmentResultByAssessmentAttemptIdConnect,
  createContentMapConnect,
  isGuestOrPremiumUserConnect,
  saveRelationshipCompatibilityResultConnect,
  saveUserAssessmentResultMapsConnect,
  createGuestUserWithoutEmailConnect,
  verifyCapchaConnect,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const signOut = useSignOut();
  const dispatch = useDispatch();
  const {
    userGUID: oldUserId,
    assessmentAttemptId,
    assessmentId,
    countryCD: reduxCountryCD,
    currencyCD,
    isPremium,
    ipAddress,
    isAuth,
  } = funnelStep || {};

  const queryParams = new URLSearchParams(location.search);
  const [modelType, setModelType] = useState("");
  const [userTraits, setUserTraits] = useState([]);
  const [resTraitType, setResTraitType] = useState();
  const [latestVersion, setLatestVersion] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingFb, setIsLoadingFb] = useState(false);
  const [isLoadingG, setIsLoadingG] = useState(false);
  const [isLoadingApple, setIsLoadingApple] = useState(false);
  const [isParentUserGuestOrPremium, setIsParentUserGuestOrPremium] =
    useState(false);
  const [isCaptchaVisible, setIsCaptchaVisible] = useState(false);
  const [isCaptchaSuccessState, setIsCaptchaSuccessState] = useState(false);
  const [captchaTokenState, setCaptchaTokenState] = useState(null);
  const [captchaTimeState, setCaptchaTimeState] = useState(null);
  const [userPassword, setUserPassword] = useState("");
  const recaptchaRef = useRef(null);
  // const token = getCookie("jwtToken");
  const { t } = useTranslation();
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  const localeForLink = locale ? `/${locale}` : "";
  const planPath = PathHelper(APP_NAVIGATION.PLANIQ, currentLocale);

  const loginPath = PathHelper(APP_NAVIGATION.SINIIQ, currentLocale);

  const parentIdFromQuery =
    isValidGuid(queryParams.get("prntid")) && queryParams.get("prntid");
  const assessmentMapIdFromQuery =
    isValidGuid(queryParams.get("assessmapid")) &&
    queryParams.get("assessmapid");
  const captchaContainerRef = useRef(null);
  // const dashboardAbTestValue = getCookie("dashboardAbTestValue");
  const dashboardPath = PathHelper(APP_NAVIGATION.DASHBOARD_B, currentLocale);
  // const token = localStorage.getItem("jwtToken");
  const assessmentAttemptIdFromQuery =
    isValidGuid(queryParams.get("assessmentAttemptId")) &&
    queryParams.get("assessmentAttemptId");
  const paymentPageUrl = `${planPath.next}${
    assessmentAttemptIdFromQuery
      ? `?assessmentAttemptId=${assessmentAttemptIdFromQuery}`
      : ""
  }`;

  const countryCD = getCountryCode(reduxCountryCD);

  const isEnneagramAssessment =
    assessmentId.toLowerCase() === ENNEAGRAM_TEST_ASSESSMENT_ID.toLowerCase();
  const isCareerPreferenceAssesment =
    assessmentId.toLowerCase() ===
    CAREER_PREFERENCE_TEST_ASSESSMENT_ID.toLowerCase();

  const isCareerAssessment =
    assessmentId.toLowerCase() === CAREER_TEST_ASSESSMENT_ID.toLowerCase();

  const isRomanticCompatibilityTest =
    convertToLowerCase(assessmentId) ===
    convertToLowerCase(ROMANTIC_COMPATIBILITY_ASSESSMENT_ID);

  const isPersonalityTestAssessment =
    convertToLowerCase(assessmentId) ===
    convertToLowerCase(PERSONALITY_TEST_ASSESSMENT_ID);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState({
    emailError: "",
    passwordError: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isLoading]);

  //Allow page scrolling once the captcha is visible
  useEffect(() => {
    if (isCaptchaVisible && captchaContainerRef.current) {
      setTimeout(() => {
        captchaContainerRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }, 100);
    }
  }, [isCaptchaVisible]);

  const mappedUserTrait = useMemo(() => {
    return userTraits?.length > 0 ? wrapScoresWithTraitLevel(userTraits) : [];
  }, [userTraits]);

  const contentKey = useMemo(
    () => generateContentKey(mappedUserTrait),
    [mappedUserTrait],
  );

  useEffect(() => {
    if (!!assessmentAttemptId) {
      getAssessmentResultByAssessmentAttemptIdConnect(assessmentAttemptId).then(
        (res) => {
          if (!!res) {
            setUserTraits(res?.userTraits);
            setModelType(res?.modelType);
            setResTraitType(res?.traitType);
          }
        },
      );
    }
  }, [assessmentAttemptId]);

  useEffect(() => {
    if (isPersonalityTestAssessment && modelType && contentKey) {
      const data = {
        modelType: modelType,
        contentKey:
          resTraitType === traitType.OPPOSITE && isPersonalityTestAssessment
            ? contentKey
            : "",
      };
      getContentLatestVersionConnect(data).then((res) => {
        if (res) {
          setLatestVersion(res);
        }
      });
    }
  }, [
    modelType,
    contentKey,
    isEnneagramAssessment,
    resTraitType,
    getContentLatestVersionConnect,
  ]);

  useEffect(() => {
    if (isRomanticCompatibilityTest && parentIdFromQuery) {
      setFormData({
        email: readCookie("email"),
      });
    }
  }, [isRomanticCompatibilityTest, parentIdFromQuery]);

  useEffect(() => {
    if (parentIdFromQuery && parentIdFromQuery !== null) {
      isGuestOrPremiumUserConnect(parentIdFromQuery).then((res) => {
        if (res) {
          setIsParentUserGuestOrPremium(res?.isPremiumOrGuestUser);
          dispatch(
            PushUserInformationToFunnelStep({
              romanticCompatibilityParentUserId: parentIdFromQuery,
            }),
          );
          // createCookie(
          //   "romanticCompatibilityParentUserId",
          //   parentIdFromQuery,
          //   1
          // );
        }
      });
    }
  }, [parentIdFromQuery]);

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      if (!!tokenResponse) {
        const userInfo = await axios
          .get(
            `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`,
            {
              headers: {
                Authorization: `Bearer ${tokenResponse.access_token}`,
              },
            },
          )
          .then((res) => {
            responseGoogle(res.data, tokenResponse.access_token);
          });
      } else {
        // setLoginError(true);
        // setLoginErrorMessage("Failed to login with google");
      }
    },
    onError: (errorResponse) => {
      // setLoginError(true);
      // setLoginErrorMessage("Failed to login with google");
      console.log(errorResponse);
    },
  });

  const handleCreateContentMap = (userGuid) => {
    if (
      isPersonalityTestAssessment &&
      userGuid &&
      contentKey &&
      modelType &&
      assessmentAttemptIdFromQuery &&
      latestVersion
    ) {
      const contentMapData = {
        userGuid,
        contentKey,
        modelType: removeWhitespace(modelType),
        assessmentAttemptId: assessmentAttemptIdFromQuery,
        version: latestVersion,
      };
      createContentMapConnect(contentMapData).then((res) => {});
    }
  };

  const handleRomanticCompatibilityResultSaving = ({ email, userGUID }) => {
    if (
      isRomanticCompatibilityTest &&
      parentIdFromQuery &&
      isParentUserGuestOrPremium
    ) {
      saveRelationshipCompatibilityResultConnect(assessmentMapIdFromQuery).then(
        (res) => {
          if (!!res) {
            const resultId = res.userTraits[0]?.userAssessmentResultId;
            const payloadAssessmentResultMap = [
              {
                userAssessmentResultId: resultId,
                sharedWithUserId: parentIdFromQuery,
              },
              {
                userAssessmentResultId: resultId,
                sharedWithUserId: userGUID,
              },
            ];
            saveUserAssessmentResultMapsConnect(
              payloadAssessmentResultMap,
            ).then((res) => {
              const guestUserPayload = {
                id: oldUserId,
                firstName: readCookie("fName") || "",
                lastName: readCookie("lName") || "",
                emailAddress: email,
                invitationStatus: InvitationStatus.Accepted,
                parentId: parentIdFromQuery,
              };
              createGuestUserWithoutEmailConnect(guestUserPayload).then(
                (res) => {
                  if (!!res) {
                    dispatch(PushGuestUserToFunnelStep(true));
                  }
                },
              );
            });
          }
        },
      );
    }
  };

  const responseGoogle = (response, accessToken) => {
    if (!!response && !!accessToken) {
      const { name, email, id } = response;
      const externalData = {
        createUser: {
          countryCD: countryCD,
          currencyCD: currencyCD,
          portalCD: getPortalCD(currentLocale),
          firstName: name,
          email: email,
          password: "",
          gender: localStorage.getItem("gender"),
          socialLogin: "google",
          locale: currentLocale,
          ...(isRomanticCompatibilityTest &&
            parentIdFromQuery &&
            isParentUserGuestOrPremium && {
              parentUserGuid: parentIdFromQuery,
            }),
        },
        externalLoginInfo: {
          loginType: 1,
          providerKey: id, // "100732998798818",
        },
      };
      setIsLoadingG(true);
      createExternalUserAccountConnect(externalData)
        .then((response) => {
          if (!!response) {
            const { isPremium, isNewUser } = response;
            setIsLoadingG(false);
            if (response.isValid) {
              const { userGuid } = response;
              trackEvents("registrationConfirmed", {
                userGuid: userGuid,
                email: email,
                eventLabel: "Registration Confirmed",
                assessmentAttemptId: assessmentAttemptId,
                assessmentId: assessmentId,
                countryCD: countryCD,
                currencyCD: currencyCD,
                portalCD: getPortalCD(currentLocale),
                visitId: readCookie("visitGuid"),
                visitorId: readCookie("visitorGuid"),
              });
              const newUserGuid = userGuid;
              const oldUserGuid = oldUserId;
              const updateUserIdPayload = {
                oldUserGuid: oldUserGuid,
                newUserGuid: newUserGuid,
                assessmentId: assessmentId,
                assessmentAttemptId: assessmentAttemptId,
              };
              if (newUserGuid && oldUserGuid) {
                updateUserIdConnect(updateUserIdPayload).then((response) => {});
              }
              if (isPremium) {
                navigate(dashboardPath.next);
              } else {
                navigate(paymentPageUrl);
              }
              handleCreateContentMap(userGuid);
              handleRomanticCompatibilityResultSaving({
                email,
                userGUID: userGuid,
              });
            } else {
              toast.error(t("login.email_taken_msg"));
            }
          }
        })
        .catch((error) => {
          setIsLoading(false);
        })
        .finally(() => {
          setIsLoadingG(false); // Stop loader
        });
    }
  };
  const responseApple = (response) => {
    setIsLoadingApple(true);

    try {
      const { authorization } = response;
      const { code, id_token } = authorization;
      const decodedToken = jwtDecode(id_token);
      const email = decodedToken?.email;

      const externalData = {
        createUser: {
          countryCD: countryCD,
          currencyCD: currencyCD,
          portalCD: getPortalCD(currentLocale),
          firstName: email ? email.split("@")[0] : "",
          lastName: "",
          email: email,
          password: "",
          socialLogin: "apple",
          ...(isRomanticCompatibilityTest &&
            parentIdFromQuery &&
            isParentUserGuestOrPremium && {
              parentUserGuid: parentIdFromQuery,
            }),
        },
        externalLoginInfo: {
          loginType: 3, // 3 represents Apple login
          providerKey: decodedToken.sub, // Use the authorization code as provider key
          idToken: id_token, // Store id_token for verification
        },
      };

      // Only proceed if we have an email
      if (!email) {
        console.error("No email received from Apple");
        toast.error(t("login.apple_login_no_email"));
        setIsLoadingApple(false);
        return;
      }

      createExternalUserAccountConnect(externalData)
        .then((response) => {
          if (!!response) {
            const { isPremium, isNewUser } = response;
            setIsLoadingG(false);
            if (response.isValid) {
              const { userGuid } = response;
              trackEvents("registrationConfirmed", {
                userGuid: userGuid,
                email: email,
                eventLabel: "Registration Confirmed",
                assessmentAttemptId: assessmentAttemptId,
                assessmentId: assessmentId,
                countryCD: countryCD,
                currencyCD: currencyCD,
                portalCD: getPortalCD(currentLocale),
                visitId: readCookie("visitGuid"),
                visitorId: readCookie("visitorGuid"),
              });
              const newUserGuid = userGuid;
              const oldUserGuid = oldUserId;
              const updateUserIdPayload = {
                oldUserGuid: oldUserGuid,
                newUserGuid: newUserGuid,
                assessmentId: assessmentId,
                assessmentAttemptId: assessmentAttemptId,
              };
              if (newUserGuid && oldUserGuid) {
                updateUserIdConnect(updateUserIdPayload).then((response) => {});
              }
              if (isPremium) {
                navigate(dashboardPath.next);
              } else {
                navigate(paymentPageUrl);
              }

              handleCreateContentMap(userGuid);
              handleRomanticCompatibilityResultSaving({
                email,
                userGUID: userGuid,
              });
            } else {
              toast.error(t("login.email_taken_msg"));
            }
          }
        })
        .catch((error) => {
          setIsLoading(false);
        })
        .finally(() => {
          setIsLoadingG(false); // Stop loader
        });
    } catch (error) {
      console.error("Apple Sign-In error:", error);
      setIsLoadingApple(false);
      toast.error(t("login.login_error_msg"));
    }
  };

  useEffect(() => {
    if (!isAllAddressCookiePresent()) {
      getIPConfig(dispatch);
    }

    trackEvents("signUpView", {
      userGuid: oldUserId,
      eventLabel: "Page View",
      assessmentAttemptId: assessmentAttemptId,
      assessmentId: assessmentId,
      countryCD: countryCD,
      currencyCD: currencyCD,
      portalCD: getPortalCD(currentLocale),
      visitId: readCookie("visitGuid"),
      visitorId: readCookie("visitorGuid"),
    });
  }, []);

  // Load Google reCAPTCHA script
  useEffect(() => {
    if (getGoogleCaptchaKey() !== "") {
      loadScript(
        "https://www.google.com/recaptcha/api.js?render=" +
          getGoogleCaptchaKey(),
      );

      return () => {
        removeScript(
          "https://www.google.com/recaptcha/api.js?render=" +
            getGoogleCaptchaKey(),
        );
      };
    }
  }, []);

  useEffect(() => {
    // Pre-load captcha script when component mounts
    if (getGoogleCaptchaKey() !== "") {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?hl=${currentLocale}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  }, [currentLocale]);

  const responseFacebook = (response) => {
    if (response.status !== "unknown") {
      const { name, email, id, accessToken } = response.authResponse;
      const graphApiUrl = `https://graph.facebook.com/me?fields=email&access_token=${accessToken}`;
      fetch(graphApiUrl)
        .then((response) => response.json())
        .then((data) => {
          const { email, id } = data;
          const externalData = {
            createUser: {
              countryCD: countryCD,
              currencyCD: currencyCD,
              portalCD: getPortalCD(currentLocale),
              firstName: name,
              gender: localStorage.getItem("gender"),
              email: email,
              password: "",
              socialLogin: "facebook",
              locale: currentLocale,
              ...(isRomanticCompatibilityTest &&
                parentIdFromQuery &&
                isParentUserGuestOrPremium && {
                  parentUserGuid: parentIdFromQuery,
                }),
            },
            externalLoginInfo: {
              loginType: 2, // Assuming 2 represents Facebook login
              providerKey: id, // Facebook User ID
            },
          };
          setIsLoadingFb(true);
          createExternalUserAccountConnect(externalData)
            .then((response) => {
              if (!!response) {
                const { isPremium, isNewUser } = response;

                if (response.isValid) {
                  const { userGuid } = response;
                  trackEvents("registrationConfirmed", {
                    userGuid: userGuid,
                    email: email,
                    eventLabel: "Registration Confirmed",
                    assessmentAttemptId: assessmentAttemptId,
                    assessmentId: assessmentId,
                    countryCD: countryCD,
                    currencyCD: currencyCD,
                    portalCD: getPortalCD(currentLocale),
                    visitId: readCookie("visitGuid"),
                    visitorId: readCookie("visitorGuid"),
                  });
                  const newUserGuid = userGuid;
                  const oldUserGuid = oldUserId;
                  const updateUserIdPayload = {
                    oldUserGuid: oldUserGuid,
                    newUserGuid: newUserGuid,
                    assessmentId: assessmentId,
                    assessmentAttemptId: assessmentAttemptId,
                  };
                  if (oldUserGuid && newUserGuid) {
                    updateUserIdConnect(updateUserIdPayload).then(
                      (response) => {},
                    );
                  }
                  if (isPremium) {
                    navigate(dashboardPath.next);
                  } else {
                    navigate(paymentPageUrl);
                  }

                  handleCreateContentMap(userGuid);
                  handleRomanticCompatibilityResultSaving({
                    email,
                    userGUID: userGuid,
                  });
                } else {
                  toast.error(t("login.email_taken_msg"));
                }
              }
            })
            .catch((error) => {
              console.error("Error during account creation: ", error);
            })
            .finally(() => {
              setIsLoadingFb(false); // Stop loader
            });

          // Use the email address here
        })
        .catch((error) => console.error("Error fetching email: ", error));
    } else {
      console.error("User did not authorize Facebook login.");
    }
  };

  const handleCaptchaSuccess = async (token) => {
    // await TrackEvent(readCookie("userguid"), "Captcha_Clicked", formData.email);
    try {
      const recaptchaScoreRequest = {
        greToken: token,
        email: formData.email,
        userGuid: oldUserId,
        portal: getPortalCD(),
      };

      const captchaResponse = await verifyCapchaConnect(
        recaptchaScoreRequest,
        userPassword,
      );

      if (captchaResponse && captchaResponse.success) {
        setIsCaptchaSuccessState(true);
        setCaptchaTokenState(token);
        setCaptchaTimeState(Date.now());
        setIsCaptchaVisible(false);
        if (isPremium) {
          navigate(dashboardPath);
        } else {
          navigate(paymentPageUrl);
        }
        handleRomanticCompatibilityResultSaving({
          email: formData.email,
          userGUID: oldUserId,
        });
        handleCreateContentMap(oldUserId);
      } else {
        setIsCaptchaSuccessState(false);
      }
    } catch (err) {
      console.error("Captcha verification failed", err);
      setIsCaptchaSuccessState(false);
      setIsCaptchaVisible(true);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let error = "";
    if (name === "email") {
      error = validateEmail(value, t);
    } else if (name === "password") {
      error = validatePassword(value, t);
    }
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    setError((prevError) => ({ ...prevError, [`${name}Error`]: error }));
  };

  useEffect(() => {
    if (isAuth === true && isPremium) {
      navigate(dashboardPath);
    } else if (isAuth === true && !isPremium) {
      navigate(planPath.next);
    } else if (!assessmentAttemptIdFromQuery) {
      signOut({ isNavigate: false });
    }
  }, [isAuth, assessmentAttemptIdFromQuery, dashboardPath, isPremium]);

  const handleSignin = async (event) => {
    event.preventDefault();
    const { email, password } = formData;
    const isEmailError = validateEmail(email.trim(), t);
    const isPwdError = validatePassword(password.trim(), t);
    const trimmedEmail = email.trim();
    const trimmedPassword = password.trim();
    if (isEmailError.length > 0) {
      setError((prevError) => ({ ...prevError, emailError: isEmailError }));
    } else {
      setError((prevError) => ({ ...prevError, emailError: "" }));
    }
    if (isPwdError.length > 0) {
      setError((prevError) => ({ ...prevError, passwordError: isPwdError }));
    } else {
      setError((prevError) => ({ ...prevError, passwordError: "" }));
    }
    if (isEmailError.length > 0 || isPwdError.length > 0) return;
    if (trimmedEmail.toLowerCase() === trimmedPassword.toLowerCase()) {
      toast.error(t("account.usernamePasswordSame"));
      return;
    }
    setUserPassword(password);
    // Check if captcha was required and validate it
    if (isCaptchaVisible || captchaTokenState) {
      const tokenAge = Date.now() - (captchaTimeState || 0);
      if (!isCaptchaSuccessState || !captchaTokenState || tokenAge > 60000) {
        setIsCaptchaVisible(true); // Show captcha again
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }
        return;
      }
    }

    // Handle IP address logic
    let finalIpAddress = ipAddress;

    // If ipAddress doesn't exist in payload but exists in redux, use redux value
    if (!finalIpAddress && ipAddress) {
      finalIpAddress = ipAddress;
    }

    // If ipAddress doesn't exist in both payload and redux, call ipconfig and save to redux
    if (!finalIpAddress) {
      try {
        const res = await getIPConfig(dispatch);

        // Use the returned IP address from getIPConfig
        finalIpAddress = res?.ipAddress;
      } catch (error) {
        console.error("Failed to get IP config:", error);
      }
    }

    const params = {
      email: email.trim(),
      password: password.trim(),
      portalCD: getPortalCD(currentLocale),
      countryCD: countryCD,
      ipAddress: finalIpAddress,
      currencyCD: currencyCD,
      existingUserId: oldUserId,
      gender: localStorage.getItem("gender"),
      locale: currentLocale,
      ...(isRomanticCompatibilityTest &&
        parentIdFromQuery &&
        isParentUserGuestOrPremium && {
          parentUserGuid: parentIdFromQuery,
        }),
    };
    setIsLoading(true);
    createUserAccountConnect(params, t)
      .then((response) => {
        if (response.isValid) {
          const { isPremium, userGuid } = response;
          trackEvents("registrationConfirmed", {
            userGuid: userGuid,
            email: email,
            eventLabel: "Registration Confirmed",
            assessmentAttemptId: assessmentAttemptId,
            assessmentId: assessmentId,
            countryCD: countryCD,
            currencyCD: currencyCD,
            portalCD: getPortalCD(currentLocale),
            visitId: readCookie("visitGuid"),
            visitorId: readCookie("visitorGuid"),
          });

          // Check for email verification status and show captcha if needed
          if (
            response?.emailVerificationSubStatus &&
            invalidMailboxStatuses.includes(
              response?.emailVerificationSubStatus,
            )
          ) {
            setIsCaptchaVisible(true);
            setTimeout(() => {
              setIsLoading(false);
            }, 2000);
            return;
          }

          if (isPremium) {
            navigate(dashboardPath);
          } else {
            navigate(paymentPageUrl);
          }
          handleRomanticCompatibilityResultSaving({
            email: formData.email,
            userGUID: oldUserId,
          });
          handleCreateContentMap(oldUserId);
        } else {
          toast.error(t("login.email_taken_msg"));
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Sign-in failed", error);
      })
      .finally(() => {
        setIsLoading(false); // Stop loader
      });
  };
  function handleError(error) {
    console.log(error);
  }
  const params = new URLSearchParams({
    assessmentAttemptId:
      assessmentAttemptIdFromQuery || assessmentAttemptId || "",
  });

  if (isRomanticCompatibilityTest && parentIdFromQuery) {
    params.set("prntid", parentIdFromQuery);
    if (assessmentMapIdFromQuery) {
      params.set("assessmapid", assessmentMapIdFromQuery);
    }
  }

  return (
    <div className="min-h-[100dvh] flex flex-col bg-surface-card">
      <Header />

      <Loader
        isLoading={isLoading || isLoadingFb || isLoadingG || isLoadingApple}
      />

      <div className="flex-1 overflow-y-auto">
        <div className="min-h-full flex justify-center px-5">
          <div className="w-full max-w-[430px] flex flex-col justify-center">
            {/* Animation / Image Placeholder */}
            <div
              className="w-full h-[120px] sm:h-[145px] mb-5 flex items-center justify-center"
              aria-hidden="true"
            >
              <div className="relative w-[120px] h-[120px] flex items-center justify-center">
                {/* Circular wave */}
                <div className=" absolute inset-0 rounded-full border-[2px] border-insightful-green animate-ftRing" />
                {/* Main circle */}
                <div className="absolute inset-[15px] rounded-full bg-[#E9F8F2] border border-insightful-green flex items-center justify-center animate-ftPop">
                  {/* Checkmark */}
                  <svg
                    className="w-[80%] h-[80%]"
                    viewBox="0 0 120 120"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M30 60L50 80L90 38"
                      fill="none"
                      stroke="#237C5E"
                      strokeWidth="9"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className="text-center">
              <span className="text-insightful-dark-green font-bold">
                {t("confirmation_iq.assessment_text_iq")}
              </span>
              {/* Sign Up Header */}
              <div className="text-center mb-7">
                <h1 className="text-[30px] sm:text-[34px] lg:text-[36px] font-bold font-montserrat leading-[1.15] tracking-[-0.02em]">
                  <span className="text-insightful-black">
                    {t("account.congrats_text")}
                  </span>
                </h1>

                <p className="text-center mt-3 mb-0 text-[12px] sm:text-[18px] lg:text-[20px] leading-[1.45] text-insightful-gray">
                  {t("account.account_creation_prompt")}
                </p>
              </div>

              {/* Social Sign-up Buttons */}
              <div className="flex flex-col gap-3">
                <FacebookProvider appId={FacebookAppId}>
                  <LoginButton
                    id="signup-facebook-button"
                    className="!w-full !h-[46px] !rounded-[12px] !bg-insightful-blue !border-0 !flex !items-center !justify-center !gap-3 !text-white !font-bold !text-[16px]"
                    scope="email"
                    onError={handleError}
                    onSuccess={responseFacebook}
                    cssClass="my-facebook-button-class"
                    icon="fa-brands fa-facebook"
                  >
                    <div className="bg-white rounded-full w-[24px] h-[24px] flex items-center justify-center p-1">
                      <img
                        src={Facebook}
                        alt="Facebook"
                        className="w-full h-full object-contain"
                      />
                    </div>

                    <span>{t("account.signup_facebook_cta")}</span>
                  </LoginButton>
                </FacebookProvider>

                <button
                  id="signup-google-button"
                  type="button"
                  className="w-full h-[46px] rounded-[12px] bg-white border border-[#DDD8D4] flex items-center justify-center gap-3 text-insightful-black font-bold text-[16px] transition hover:bg-[#FAFAFA]"
                  onClick={googleLogin}
                >
                  <div className="w-[24px] h-[24px] flex items-center justify-center">
                    <img
                      src={GoogleLoginLogo}
                      alt="Google"
                      className="w-[20px] h-[20px] object-contain"
                    />
                  </div>

                  <span>{t("account.signup_google_cta")}</span>
                </button>

                {/* Apple Signup UI */}
                <AppleSignin
                  authOptions={{
                    clientId: AppleCliendId,
                    scope: "name email",
                    redirectURI: AppleRedirectUrl,
                    nonce: "nonce",
                    usePopup: true,
                  }}
                  uiType="dark"
                  className="apple-signin-button"
                  noDefaultStyle={true}
                  onSuccess={responseApple}
                  onError={(error) => {
                    console.error("Apple Sign-In error:", error);
                    setIsLoadingApple(false);

                    // Don't show error toast for user cancellation
                    if (error?.error !== "popup_closed_by_user") {
                      handleError();
                    }
                  }}
                  skipScript={false}
                  render={(props) => (
                    <button
                      {...props}
                      id="login-apple-button"
                      type="button"
                      className="w-full h-[46px] rounded-[12px] bg-black border border-black flex items-center justify-center gap-3 text-white font-bold text-[16px] transition hover:bg-[#171717]"
                      disabled={isLoadingApple}
                      onClick={(e) => {
                        if (props.onClick) {
                          props.onClick(e);
                        }
                      }}
                    >
                      <div className="w-[24px] h-[24px] flex items-center justify-center">
                        <img
                          src={AppleLogo}
                          alt="Apple"
                          className="w-[22px] h-[22px]"
                        />
                      </div>

                      <span>{t("account.signup_apple_cta")}</span>
                    </button>
                  )}
                />
              </div>

              {/* OR Divider */}
              <div className="flex items-center gap-3 my-7">
                <div className="flex-1 h-px bg-divider-bar" />

                <span
                  id="signup-or-text"
                  className="text-[13px] font-medium text-insightful-gray whitespace-nowrap"
                >
                  {t("confirmation_iq.or_text_iq")}
                </span>

                <div className="flex-1 h-px bg-divider-bar" />
              </div>

              {/* Sign-up Form */}
              <div className="w-full">
                <form
                  id="signup-form"
                  className="w-full flex flex-col gap-4"
                  onSubmit={handleSignin}
                >
                  <AppTextField
                    id="signup-email-input"
                    label={t("confirmation_iq.email_label_iq")}
                    name="email"
                    onChange={handleInputChange}
                    value={formData.email}
                    error={error.emailError}
                    inputClassName="focus:border-insightful-dark-orange focus:ring-2 focus:ring-insightful-dark-orange/20 "
                    placeholder={t("confirmation_iq.email_placholder_iq")}
                  />

                  <AppTextField
                    id="signup-password-input"
                    label={t("account.password_label")}
                    name="password"
                    onChange={handleInputChange}
                    value={formData.password}
                    error={error.passwordError}
                    type="password"
                    inputClassName="focus:border-insightful-dark-orange focus:ring-2 focus:ring-insightful-dark-orange/20 "
                    placeholder={t("account.password_placeholder")}
                  />

                  {/* Submit Button */}
                  <AppButton
                    id="signup-submit-button"
                    disabled={isCaptchaVisible}
                    type="submit"
                    className={`!w-full !h-[50px] !rounded-[12px] !bg-[#FF8568] hover:!bg-insightful-orange !text-white !font-bold !text-[16px] !border-0 !shadow-none focus:!outline-none focus:!ring-2 focus:!ring-[#FE6634]/30 ${
                      isCaptchaVisible ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  >
                    {t("confirmation_iq.create_account_cta_iq")}→
                  </AppButton>

                  {/* Consent Text */}
                  <div
                    id="signup-consent-text"
                    className="text-[12px] sm:text-[13px] leading-[1.55] text-insightful-gray"
                  >
                    <p>
                      {t("account.consent_confirmation_text")}
                      &nbsp;
                      <Link
                        id="signup-terms-link"
                        to={`https://insightfultraits.com${localeForLink}/terms-conditions/`}
                        className="text-insightful-dark-orange underline"
                        target="_blank"
                      >
                        {t("account.term_of_use")}
                      </Link>{" "}
                      {t("account.and")}{" "}
                      <Link
                        id="signup-privacy-link"
                        to={`https://insightfultraits.com${localeForLink}/privacy-policy`}
                        className="text-insightful-dark-orange underline"
                        target="_blank"
                      >
                        {t("account.privacy_policy")}
                      </Link>
                      .
                    </p>
                  </div>

                  {/* Already have account section */}
                  <div
                    id="signup-login-link-container"
                    className="text-center text-[13px] sm:text-[14px] mt-1 mb-8 text-insightful-black"
                  >
                    <p>
                      {t("account.already_account")}&nbsp;
                      <Link
                        id="signup-login-link"
                        to={`${loginPath.next}?${params.toString()}`}
                        className="text-insightful-dark-orange  hover:underline font-bold"
                        onClick={() => {
                          if (window.olark) {
                            window.olark("api.box.show");
                          }
                        }}
                      >
                        {t("account.member_login")}
                      </Link>
                    </p>
                  </div>

                  {isCaptchaVisible && (
                    <div ref={captchaContainerRef}>
                      <GoogleCaptcha onCaptchaSuccess={handleCaptchaSuccess} />
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer_V2 />
    </div>
  );
};

export default SignupIQ;
